import { combineReducers } from '@reduxjs/toolkit';

import service from './service';
import customer from './customer';
import device from './device';

const rootReducer = combineReducers({
  service,
  customer,
  device,
});

export default rootReducer;
